import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type {
  PagedResponse,
  RecordStatusBody,
  TemplateParamGroup,
  TemplateParamGroupUpsert,
} from '../types'

const BASE = '/management/template-param-groups'

/*
 * **Grup ekleme/silme sarmalayıcısı yoktur** (2026-08-03 kararı): yönetim ekranında gruplar yalnız
 * düzenlenir ve durumu değiştirilir. Sunucudaki `POST` / `DELETE` uçları yerinde durur (bilinçli
 * tercih), ama istemci bunları çağırmaz — çağrılmayan bir sarmalayıcı, ekranda olmayan bir yeteneğin
 * var olduğu izlenimini bırakır.
 */

export interface TemplateParamGroupQuery {
  page: number
  size: number
  /** Kolon sıralaması (`alan,asc|desc`); yoksa gönderilmez → sunucu varsayılanı (kimlik). */
  sort?: string
}

/** Grup listesi (059) — sunucu-tarafı sayfalama + **kolon sıralaması** (`useTableSort`). */
export async function getTemplateParamGroups({
  page,
  size,
  sort,
}: TemplateParamGroupQuery): Promise<PagedResponse<TemplateParamGroup>> {
  const { data } = await apiClient.get<PagedResponse<TemplateParamGroup>>(BASE, {
    params: { page, size, sort },
  })
  return data
}

/** Grup güncelleme; `modDate` optimistic lock için zorunludur. */
export async function updateTemplateParamGroup(
  id: number,
  body: TemplateParamGroupUpsert,
): Promise<TemplateParamGroup> {
  const { data } = await apiClient.put<TemplateParamGroup>(`${BASE}/${id}`, body)
  return data
}

/** Durum degistir - yalniz 0 (Pasif) <-> 1 (Aktif); `modDate` optimistic lock icin zorunlu. */
export async function changeTemplateParamGroupStatus(
  id: number,
  body: RecordStatusBody,
): Promise<TemplateParamGroup> {
  const { data } = await apiClient.put<TemplateParamGroup>(`${BASE}/${id}/status`, body)
  return data
}

/**
 * Şablon parametre gruplarını Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportTemplateParamGroups(sort?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { sort }, 'sablon-parametre-gruplari.xlsx')
}
